module.exports = __webpack_public_path__ + "img/shoot_00025.bf796bc3.png";